var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalogItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 380,
    viewBox: "0 0 380 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.29 193.017L80.0077 131.387L80.0077 254.648L80.0039 254.65L80.0077 254.652V254.661L80.0157 254.657L185.298 316.287L185.298 193.026L185.302 193.024L185.298 193.022V193.012L185.29 193.017Z",
    fill: "#E9E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.699 193.004L299.994 254.642L299.994 131.367L194.699 193.004ZM299.997 254.646L194.703 316.283L194.703 193.009L299.997 254.646Z",
    fill: "#E9E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.306 186.982L85.0117 125.344L190.306 63.707L190.306 186.982ZM190.307 186.99L295.601 125.352L190.307 63.715L190.307 186.99Z",
    fill: "#E9E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogItem);
export default __webpack_public_path__ + "static/media/catalog-item.81c2657bd59d8e8d244e4d8a09d6b056.svg";
export { ForwardRef as ReactComponent };